import Phaser, { GameObjects } from "phaser";
 
var keyM
 
export default class Start extends Phaser.Scene {
    // Variablen belegen
    private graphCount: number = 0
    private graphNames = ['start1', 'start2', 'start3', 'start4', 'start5']
    private image
    private thrill!: Phaser.Sound.BaseSound
    private backgroundmusic!: Phaser.Sound.BaseSound
    private backwardEllipse!: GameObjects.Ellipse;
    private forwardEllipse!: GameObjects.Ellipse;
    private forwardGraphic!: GameObjects.Graphics;
    private backwardGraphic!: GameObjects.Graphics;
    private downloadButton;
    textarray: any;
    textarray1: any;
    textarray2: any;
    textarray0: any;
    textarray5: any;
 
    constructor() {
        super('start');
    }
 
    create() {
        // Anfangssequenz einbinden
        this.image = this.add.image(512, 288, this.graphNames[this.graphCount])
            .setScale(0.4)
        this.forwardEllipse = this.add.ellipse(974, 520, 50, 50, 0xffffff, 75)
            .setStrokeStyle(2, 0xffffff)
            .setInteractive()
            .setName('forward')
            .setDepth(10)
        this.forwardGraphic = this.add.graphics({x: 960, y: 515})
            .fillStyle(0x000000)
            .strokeRect(0, 0, 20, 10)
            .fillRect(0, 0, 20, 10)
            .setDepth(12)
            .fillTriangle(20, 15, 20, -5, 30, 5)
        this.backwardEllipse = this.add.ellipse(50, 520, 50, 50, 0xffffff, 75)
            .setStrokeStyle(2, 0xffffff)
            .setInteractive()
            .setName('backward')
            .setDepth(10)

        //Löschen aller Fragen-IDs aus dem Sessionstorage bei Neuladen des Spiels
        Object.keys(sessionStorage).forEach(key => {
        if (key.startsWith('usedQuestionIds_')) {
           sessionStorage.removeItem(key);
        }
        });


        sessionStorage.setItem('resetIds', 'true');

 
                     
            // Einfügen der Texte auf den Bildern zur Erklärung der Spielsituation im html-Format
            
            // Texte Bild 4
            this.textarray = this.add.container(0, 0);
            this.textarray1 = this.add.container(0, 0);
            this.textarray2 = this.add.container(0, 0);
            

            let Text4 = `Auftrag:
Für diesen Auftrag kommen nur die besten Agentinnen und 
Agenten des Geheimdienstes in Frage. Damit unser Team 
erfolgreich ist, haben wir Dich ausgewählt, da Du 
außergewöhnliche Fähigkeiten hast, um diese schwierige
Aufgabe zu meistern.

Euer Auftrag ist es, möglichst viele Daten zu beschaffen und 
zu analysieren, die der Dienst FakeBook von Nutzenden 
speichert. Damit wollen wir nachweisen, dass systematisch
und massenhaft Daten gesammelt, verkauft und ausgewertet
werden, von denen die Nutzenden nicht im Geringsten etwas
ahnen.

Dafür musst Du in den Server-Raum der FakeBook-Zentrale 
eindringen, um auf die gespeicherten Daten zugreifen zu 
können. Die Zentrale ist jedoch gut bewacht durch Kameras, 
Zäune und Sicherheitsleute. Nur Du alleine bist fähig, 
diesen auszuweichen und mithilfe der Rätsel die gesperrten 
Türen zu öffnen, um in den Server-Raum einzudringen.

Als Unterstützung wird Dir Agent 0711 zur Seite stehen. 
Alles weitere wird er Dir gleich selbst erzählen.

Von Deinem Einsatz hängt es ab, ob wir es schaffen, 
den Datenkraken das Handwerk zu legen.

Viel Erfolg
– Mr. X`;

            let text = this.add.text(400, 10, Text4, {
             fontFamily: 'Arial',
             fontSize: '13.5px',
             color: '#000000',
             wordWrap: { width: 500 }
            });

            this.textarray.add([text]);
            this.textarray.setDepth(10).setVisible(false);
            this.textarray.rotation = 0.05;

            
            let Text42 = `FakeBook-Zentrale`;

            let text42 = this.add.text(200, 292, Text42, {
             fontFamily: 'Arial',
             fontSize: '12px',
             color: '#000000',
             wordWrap: { width: 500 }
            });

            
            this.textarray1.add([text42]);
            this.textarray1.setDepth(10).setVisible(false);
            this.textarray1.rotation = -0.15;

            let Text43 = `Agent 0711`;

            let text43 = this.add.text(823, 294, Text43, {
             fontFamily: 'Arial',
             fontSize: '12px',
             color: '#000000',
             wordWrap: { width: 500 }
            });

            
            this.textarray2.add([text43]);
            this.textarray2.setDepth(10).setVisible(false);
            this.textarray2.rotation = 0.2;

            // Text Bild 2
            this.textarray0 = this.add.container(0, 0);
            let Text0 = `Unternehmen sammeln auf so viele Arten unsere Daten, dass sie \nselbst den Überblick darüber verlieren, wie sie uns verfolgen. \nUnd dennoch geben wir ihnen unsere Daten freiwillig. 

Privatsphäre im Internet ist heute kein Grundrecht mehr, \nsondern ein Luxusprivileg, welches für die Mehrheit der \nWeltbevölkerung nicht mehr zugänglich ist... `;

            let text0 = this.add.text(41, 70, Text0, {
             fontFamily: 'Arial',
             fontSize: '22px',
             color: '#008000',
            });

            
            this.textarray0.add([text0]);
            this.textarray0.setDepth(10).setVisible(false);
            this.textarray0.rotation = 0;


             // Text Bild 5
             this.textarray5 = this.add.container(0, 0);
             let Text5 = `                                  Hallo, 

   ich bin Agent 0711. Ich hoffe, Du hast Dich \nauf den bevorstehenden Auftrag gut vorbereitet. \nEs wird extrem anspruchsvoll.

Aber keine Sorge, ich werde Dich die ganze Zeit \nvon außen unterstützen. Wir können per Funk \nkommunizieren. Ich versuche, Dir so Tipps zu geben.

      Wir sehen uns vor dem Parkplatz der \n         FakeBook-Zentrale. Bis gleich... 
`;
 
             let text5 = this.add.text(41, 70, Text5, {
              fontFamily: 'Arial',
              fontSize: '25px',
              color: '#000000',
             });
 
             
             this.textarray5.add([text5]);
             this.textarray5.setDepth(10).setVisible(false);
             this.textarray5.rotation = 0;
 



 
        //Button zur Seite mit den Arbeitsmaterialien
        this.downloadButton = this.add.container(0, 0); //Container erstellen, um Button und Text gemeinsam zu verwalten
 
        const buttonWidth = this.scale.width / 4.5;
        const buttonHeight = this.scale.height / 15;
        const padding = 20;
 
        const buttonXX = padding + buttonWidth / 2;
        const buttonYY = this.scale.height - padding - buttonHeight / 2;
 
       
        const buttonBackground = this.add.rectangle(
           buttonXX,
           buttonYY,
           buttonWidth,
           buttonHeight,
           0x333333
        )
         .setInteractive()
         .setStrokeStyle(2, 0xffffff)
         .on('pointerover', () => buttonBackground.setFillStyle(0x555555))
         .on('pointerout', () => buttonBackground.setFillStyle(0x333333))
         .on('pointerdown', () => {
           //window.location.href = 'https://social.dhbw-stuttgart.de/Arbeitsmaterialien/download.html';
           window.open('https://social.dhbw-stuttgart.de/Arbeitsmaterialien/download.html', 'Game2020');
         });
 
        //Text auf dem Button
        const buttonText = this.add.text(
           buttonXX,
           buttonYY,
            'Arbeitsmaterialien',
             {
               fontSize: '20px',
               color: '#ffffff',
               fontFamily: 'Arial',
             }
            ).setOrigin(0.5);
 
        // Button und Text zum Container hinzufügen
        this.downloadButton.add([buttonBackground, buttonText]);
 
        this.downloadButton.setDepth(10).setVisible(true);
 
 
       /* this.downloadButton = this.add.text(15, 525, 'Arbeitsmaterialien', {
            fontFamily: 'Arial',
            fontSize: '20px',
            color: '#ffffff'
            })
            .setInteractive()
            .setDepth(10)
            .on('pointerdown', () => {
            window.location.href = 'https://social.dhbw-stuttgart.de/Arbeitsmaterialien/download.html';
            });*/
 
 
 
        this.backwardGraphic = this.add.graphics({x: 45, y: 515})
            .fillStyle(0x000000)
            .strokeRect(0, 0, 20, 10)
            .fillRect(0, 0, 20, 10)
            .setDepth(12)
            .fillTriangle(0, 15, 0, -5, -10, 5)
 
        this.input.on('gameobjectdown', this.handleClick, this)
 
        //Tasten belegen für Musiksteuerung
        //if(this.input?.keyboard){
        //    keyM = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.M)
        //}
    }
 
    // Bei Klick entsprechend vorwärts oder rückwärts navigieren
    handleClick(pointer: Phaser.Input.Pointer, gameObject: Phaser.GameObjects.GameObject) {
        this.image.destroy()
        if (gameObject.name == 'forward') {
            this.graphCount++
        } else {
            this.graphCount--
        }
        //console.log(this.graphCount)

        // Sorgt dafür, dass die html-Texte der Bilder nur auf dem gewollten Bild angezeigt werden
        if (this.graphCount == 1){
            this.textarray0.setVisible(true);
        }else{
            this.textarray0.setVisible(false);
        }
        if (this.graphCount == 3){

            this.textarray.setVisible(true);
            this.textarray1.setVisible(true);
            this.textarray2.setVisible(true);
        }
        else{
            this.textarray.setVisible(false);
            this.textarray1.setVisible(false);
            this.textarray2.setVisible(false);
        }
        if (this.graphCount == 4){
            this.textarray5.setVisible(true);
        }else{
            this.textarray5.setVisible(false);
        }
        if (this.graphCount == 5) {
            this.scene.stop()
            this.scene.start('characterselection')
        } else if (this.graphCount == -1) {
            this.graphCount = 0
        }
        this.image = this.add.image(512, 288, this.graphNames[this.graphCount])
            .setScale(0.4)
    }
   
 
 
    update(time: number, delta: number) {
        //Sound-Taste gedrückt
        /*if (Phaser.Input.Keyboard.JustDown(keyM)) {
            var flag = sessionStorage.getItem('flag');
            console.log(flag)
            if (flag == "true") {
                this.sound.stopAll() //Musik ausschalten
                sessionStorage.setItem('flag', "false");
            } else if (flag == "false") { //Musik anschalten
                this.backgroundmusic = this.sound.get('backgroundmusic')
                this.sound.stopAll()
                this.thrill = this.sound.add('backgroundmusic', {volume: 0.5, loop: true})
                this.thrill.play() //Musik anschalten
                sessionStorage.setItem('flag', "true");
            }
        } */
 
        //Erster Pfeil nach links entfernen
        if (this.graphCount == 0) {
            this.backwardEllipse.setVisible(false)
            this.backwardGraphic.setVisible(false)
            this.downloadButton.setVisible(true)
        } else {
            this.backwardEllipse.setVisible(true)
            this.backwardGraphic.setVisible(true)
            this.downloadButton.setVisible(false)
        }
 
    }
 
}